<div class="embed">
	<iframe id="docIframe" [src]="url" width="100%" height="100%"></iframe>
</div>
